module.exports = __webpack_public_path__ + "fonts/020c97d.woff2";